angular.module("digitalLeasing.module")
  .component("deliberaBanca", {
    templateUrl: "ng/components/digitalLeasing/deliberaBanca/deliberaBanca.view.html",
    bindings: {
      model: "=",
    },
    controllerAs: "deliberaBancaCtrl",
    controller: function DeliberaBanca($typeDomainService) {
      var self = this;

      self.$onInit = function () {
        jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
        console.log("model deliberaBanca", self.model);
        self.isPending = true;

        $typeDomainService
          .getDomainSet("BANK_RESOLUTION", "CHECKS")
          .then(function (response) {
            console.log("response", response);
            self.domande = response.domainList;
            self.isPending = false;
          })
          .catch(function (error) {
            console.log("error:", error);
          });
      };
    },
  });